module.exports = __webpack_public_path__ + "static/media/Hat_3.23322a73.jpg";